<section class="custom-modal" role="dialog" aria-modal="true" aria-labelledby="customise-permissions-title">
  <header class="modal-header">
    <div class="modal-header-text">
      <h2 id="customise-permissions-title" class="modal-title">Customise Permissions</h2>
      @if (contextLabel) {
        <p class="modal-subtitle">{{ contextLabel }}</p>
      }
    </div>
    <button type="button" class="icon-button" aria-label="Close" (click)="onCancel()">
      <app-display-icon [border]="false" [colour]="iconColourEnum.primary" [icon]="icons.close">
      </app-display-icon>
    </button>
  </header>

  <div class="modal-body">
    @for (section of sections; track trackSection($index, section)) {
      <div class="perm-section" [class.perm-section-spaced]="$index > 0">
        @if (section.category) {
          <p class="perm-section-title">{{ section.category }}</p>
        }
        @for (node of section.nodes; track trackNode($index, node)) {
          <div class="perm-node-group">
            @if (isAdminRule(node)) {
              <div class="perm-row perm-row-disabled" [title]="'Admin-only — grants full access to everything and cannot be set individually.'">
                <input type="checkbox" disabled class="perm-checkbox" />
                <span class="perm-label perm-label-disabled">{{ node.label }}</span>
              </div>
            } @else if (hasChildren(node)) {
              <label class="perm-row">
                <input
                  type="checkbox"
                  class="perm-checkbox"
                  [checked]="allChildrenChecked(node)"
                  [indeterminate]="isNodeIndeterminate(node)"
                  (change)="onCheckboxChange(node, $event)" />
                <span
                  class="perm-label perm-label-parent"
                  [matTooltip]="node.tooltip ?? ''"
                  [matTooltipDisabled]="!node.tooltip">
                  {{ node.label }}
                </span>
              </label>
              @for (child of node.children; track trackNode($index, child)) {
                <label class="perm-row perm-row-child">
                  <input
                    type="checkbox"
                    class="perm-checkbox"
                    [checked]="isChecked(child)"
                    (change)="onCheckboxChange(child, $event)" />
                  <span
                    class="perm-label"
                    [matTooltip]="child.tooltip ?? ''"
                    [matTooltipDisabled]="!child.tooltip">
                    {{ child.label }}
                  </span>
                </label>
              }
            } @else {
              <label class="perm-row" [class.perm-row-child]="node.indent">
                <input
                  type="checkbox"
                  class="perm-checkbox"
                  [checked]="isChecked(node)"
                  [disabled]="isCheckboxDisabled(node)"
                  (change)="onCheckboxChange(node, $event)" />
                <span
                  class="perm-label"
                  [class.perm-label-parent]="!node.indent"
                  [matTooltip]="node.tooltip ?? ''"
                  [matTooltipDisabled]="!node.tooltip">
                  {{ node.label }}
                </span>
              </label>
            }
          </div>
        }
      </div>
    }
  </div>

  <footer class="modal-footer">
    <span class="selected-count">{{ selectedCount }} permission{{ selectedCount === 1 ? '' : 's' }} selected</span>
    <div class="modal-footer-actions">
      <app-shared-button [colour]="'primary'" (click)="onCancel()">Cancel</app-shared-button>
      <app-shared-button [colour]="'primary'" [disabled]="!hasChanges()" [fill]="true" (click)="onSave()">Save</app-shared-button>
    </div>
  </footer>
</section>
